import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	return {
		mainContainer: {
			height          : "100vh",
			display         : "flex",
			flexDirection   : "column",
			overflow        : "hidden",
			alignItems      : "center",
			backgroundColor : theme.other.colors.background.primary
		},
		topHeader: {
			backgroundColor : theme.other.colors.dialog.primary,
			display         : "flex",
			alignItems      : "center",
			padding         : "0rem 2.5rem",
			justifyContent  : "space-between",
			height          : "80px",
			borderBottom    : theme.other.darkMode ? undefined : `1px solid ${ theme.other.colors.input.primary }`

		},
		tabsRoot: {
			flex          : "1",
			overflow      : "hidden",
			height        : "100%",
			display       : "flex",
			flexDirection : "column"
		},
		loginButton: {
		},
		tab: {
			fontWeight       : "500",
			flex             : "1",
			padding          : "1.75rem 1rem",
			backgroundColor  : "transparent !important",
			color            : theme.other.colors.text.secondary,
			borderWidth      : "2px",
			borderColor      : "transparent",
			display          : "none !important",
			"&[data-active]" : {
				color: theme.other.paletteNew.primaryDarkBlue
			},
			"&:focus": {
			}
		},
		tabsList: {
			border          : "none",
			backgroundColor : theme.other.colors.dialog.primary
		},
		panel: {
			overflow: "auto"
		},
		innerContainer: {
		},
		priorityBox: {
			display      : "flex",
			alignItems   : "center",
			background   : theme.other.paletteNew.primaryLightBlue,
			margin       : "1.5rem",
			borderRadius : "1.5rem"
		},
		itemCard: {
			backgroundColor : props?.selfCard ? theme.other.colors.dialog.primary : undefined,
			borderTop       : theme.other.darkMode ? undefined : props?.selfCard ? `1px solid ${ theme.other.colors.input.primary }` : undefined,
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between",
			width           : "100%",
			borderBottom    : `1px solid ${ theme.other.colors.input.primary }`,
			padding         : "1.5rem 1rem",
			paddingRight    : "2rem"

		},
		loginButtonContainer: {
			padding: "1rem"
		},
		selfCardContainer: {
			position        : "fixed",
			bottom          : "0",
			width           : "100%",
			backgroundColor : theme.other.colors.background.primary,
			left            : "50%",
			transform       : "translate(-50%,0)",
			maxWidth        : "450px"
		},
		listContainer: {
			display       : "flex",
			flexDirection : "column",
			marginBottom  : "8rem"
		},
		itemPhoto: {
			borderRadius : "100%",
			height       : "4rem",
			width        : "4rem"
		},
		itemPhotoContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		itemLeft: {
			display    : "flex",
			gap        : "1.5rem",
			alignItems : "center"

		},
		itemRight: {
		},
		donationContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			gap            : "0.5rem"
		},
		donationText: {
			color: theme.other.colors.text.secondary
		},
		donation: {
			// minWidth: "50px"
		},
		drawerContent: {
			backgroundColor : theme.other.colors.dialog.secondary,
			borderRadius    : "2rem 2rem 0 0",
			// padding         : "1rem",
			height          : "unset"
		},
		drawerHeader: {
			width           : "100%",
			backgroundColor : theme.other.colors.dialog.primary,
			padding         : "1.5rem 2rem",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between"
		},
		drawerInner: {
			padding: "1rem"
		},
		infoItem: {
			color: theme.other.colors.text.secondary
		},
		infoList: {
			margin       : "0",
			marginBottom : "1rem",
			paddingLeft  : "3rem"
		},
		rank: {
			color          : theme.other.colors.text.secondary,
			fontWeight     : "500",
			minWidth       : "4rem",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		trophyImage: {
			height   : "100%",
			width    : "unset",
			minWidth : "100px"
		},
		topContent: {
			padding: "1rem"
		},
		dominationHeading: {
			// flex   : "1",
			width  : "150px",
			margin : "1rem 5rem"
		},
		container: {
			maxWidth      : "450px",
			width         : "100%",
			height        : "100vh",
			overflow      : "hidden",
			display       : "flex",
			flexDirection : "column"
		},
		topBanner: {
			borderRadius: "1.5rem"
		},
		bannerContainer: {
			padding: "2rem"
		},
		actionIcon: {
			height          : "unset",
			width           : "unset",
			backgroundColor : "transparent",
			":hover"        : {
				backgroundColor: "transparent"
			}
		}
	};
} );